import { ContentProps } from "./Content.types";
import { Alert, AlertTitle, AlertDescription } from "@shadcn/components/ui/alert";
import { AlertVariant } from "@schema-types/types/JourneySchema";
import * as Icons from "lucide-react";

export const Content = ({ config }: ContentProps) => {
  const { icon, title, content } = config;

  // Get the icon component dynamically
  const IconComponent = icon ? (Icons[icon as keyof typeof Icons] as React.ComponentType<any>) : null;

  return (
    <Alert variant={getAlertVariant()} className="jb-content">
      {IconComponent && <IconComponent className="h-4 w-4" />}
      {title && <AlertTitle className="mb-2">{title}</AlertTitle>}
      <AlertDescription>
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </AlertDescription>
    </Alert>
  );

  function getAlertVariant() {
    let alertVariant: "default" | "destructive" | "warning" | "info" | "success" = "default";
    switch (config.alertVariant) {
      case AlertVariant.Default:
        alertVariant = "default";
        break;
      case AlertVariant.Destructive:
        alertVariant = "destructive";
        break;
      case AlertVariant.Warning:
        alertVariant = "warning";
        break;
      case AlertVariant.Info:
        alertVariant = "info";
        break;
      case AlertVariant.Success:
        alertVariant = "success";
        break;
    }
    return alertVariant;
  }
};
